import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/app/series/create')({
  component: lazyRouteComponent(() => import('./-create')),
})
